// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import "rxjs/Rx";
import {UtilConfig} from "../../../../autenticacion/servicios/UtilConfig";
import * as moment from 'moment';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {WebServices} from "../../../recursos/modelo/consumerModel/web-services.enum";
import {ConsumerService} from "../../../recursos/servicio/consumer.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Emisor} from "../../seguridad/emisor/recursos/modelo/emisor";

declare const $: any;

declare var swal: any;

declare let d3: any;


@Component({
    selector: 'app-registroVentas',
    templateUrl: './view/registroVenta.component.html',
    styleUrls: ['./css/registroVenta.component.scss'],
    providers: [ConsumerService]
})
export class RegistroVentaComponent implements OnInit {

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─
    cargando = false;
    rangeDates: Date[] = [new Date(), new Date()];
    filtroList = {
        fechaDesde: this.rangeDates[0],
        fechaHasta: this.rangeDates[1]
    };
    bsConfig: Partial<BsDatepickerConfig>;
    colorTheme = 'theme-dark-blue';
    email = '';
    emisor: Emisor;
    locale = 'es';
    respuesta = null;

    constructor(private route: ActivatedRoute,
                private router: Router,
                public jwtUtil: UtilConfig,
                private snackBar: MatSnackBar,
                public consumerService: ConsumerService,
                private _localeService: BsLocaleService) {

        this._localeService.use(this.locale);

        this.bsConfig = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'DD/MM/YYYY',
            minDate: moment().subtract(190, 'day').toDate(),
            maxDate: new Date()
        });

        this.emisor = jwtUtil.getCurrentUser().customer;
    }


    ngOnInit() {
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴

    validateEmail() {
        if (!this.validarEmail(this.email)) {
            this.email = '';
        }
    }

    validarEmail(valor) {
        if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(valor)) {
            return true;
        } else {
            this.snackBar.open('La dirección de email es incorrecta!.', null, {duration: 2000});
            return false;
        }
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘


    generar() {
        // LLAMADO AL SERVICIO
        if (this.email != '') {
            this.cargando = true;
            let param = {
                numRuc: this.emisor.ruc,
                email: this.email,
                generateDate: moment(new Date()).format('YYYY-MM-DD'),
                requestDate: moment(new Date()).format('YYYY-MM-DD'),
                startDate: moment(this.rangeDates[0]).format('YYYY-MM-DD'),
                endDate: moment(this.rangeDates[1]).format('YYYY-MM-DD'),
            }
            this.consumerService.post(WebServices.URL_SALE_RECORD, {salesRecord: param})
                .subscribe(result => {
                    this.cargando = false;
                    this.respuesta = result.codigo;
                }, err => {
                    this.cargando = false;
                    this.respuesta = 0;
                    this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo generar el registro de ventas", this.router)

                });
        }
    }


}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/reporte/registroVenta/registroVenta.component.ts